const tryLoadProperties = async (context, obj, ...properties) => {
    if (!context) {
        throw new Error("Missing context.");
    }

    if (!obj) {
        throw new Error("An object must be supplied.");
    }

    let success = true;
    for (let i = 0; i < properties.length; i++) {
        const property = properties[i];

        try {
            obj.load(property);
            await context.sync();
        } catch (error) {
            /* There is no way to test for a property before trying to load it. */
            success = false;
        }
    }

    return success;
}

export {
    tryLoadProperties
}

export default {
    tryLoadProperties
}